import { render, staticRenderFns } from "./CogMenu.vue?vue&type=template&id=0c9a9898&"
import script from "./CogMenu.vue?vue&type=script&lang=ts&"
export * from "./CogMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports